import { useContext } from 'react'
import { ReadOnlyContext, type ReadOnlyContextValue } from './ReadOnlyContextDef'

export function useReadOnlyContext(): ReadOnlyContextValue {
  return useContext(ReadOnlyContext)
}
